import { createAsyncThunk } from '@reduxjs/toolkit';
import { API_ENDPOINTS } from '../../config/api';

export const registerUser = createAsyncThunk(
  'auth/register',
  async (userData, { rejectWithValue }) => {
    try {
      const { website, honeypot, ...cleanUserData } = userData;

      const checkResponse = await fetch(API_ENDPOINTS.CHECK_EMAIL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email: cleanUserData.email }),
      });

      const checkData = await checkResponse.json();

      if (checkData.exists) {
        return rejectWithValue({
          message: 'Email already registered',
          emailExists: true,
          email: cleanUserData.email
        });
      }

      // Ensure suspicious patterns are detected
      const suspiciousPatterns = [
        /@(temp|fake|temporary)\./i,
        /[<>{}()$]/
      ];

      if (suspiciousPatterns.some(pattern =>
        pattern.test(cleanUserData.email) || pattern.test(cleanUserData.name)
      )) {
        return rejectWithValue('Invalid input detected');
      }

      const response = await fetch(API_ENDPOINTS.REGISTER, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(cleanUserData),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || 'Registration failed');
      }

      return data;
    } catch (error) {
      return rejectWithValue('Network error occurred');
    }
  }
);


export const loginUser = createAsyncThunk(
  'auth/login',
  async (credentials, { rejectWithValue }) => {
    try {
      const response = await fetch(API_ENDPOINTS.LOGIN, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': credentials.token ? `Bearer ${credentials.token}` : '',
        },
        body: JSON.stringify(credentials),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message || 'Login failed');
      }

      return data;
    } catch (error) {
      return rejectWithValue('Network error occurred');
    }
  }
);

export const checkEmail = createAsyncThunk(
  'auth/checkEmail',
  async (email, { rejectWithValue }) => {
    try {
      // Validate email against suspicious patterns
      const suspiciousPatterns = [
        /@(temp|fake|temporary)\./i,
        /[<>{}()$]/
      ];

      if (suspiciousPatterns.some(pattern => pattern.test(email))) {
        return rejectWithValue('Invalid input detected');
      }

      const response = await fetch(API_ENDPOINTS.CHECK_EMAIL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email }),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message);
      }

      return data;
    } catch (error) {
      return rejectWithValue('Network error occurred');
    }
  }
);

export const resetPassword = createAsyncThunk(
  'auth/resetPassword',
  async ({ email, token, password }, { rejectWithValue }) => {
    try {
      const response = await fetch(API_ENDPOINTS.RESET_PASSWORD, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
        body: JSON.stringify({ email, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        return rejectWithValue(data.message);
      }

      return data;
    } catch (error) {
      return rejectWithValue('Network error occurred');
    }
  }
);